import { ComponentProps } from 'react'
import { Chip } from '@common/ui'
import { useImpersonation } from '../../io/context/ImpersonationContext'
import EntityLink from '../data/EntityLink'

const ImpersonationChip = () => {
  const { impersonatedUserId, isImpersonating, stopImpersonation } = useImpersonation()
  if (!isImpersonating || !impersonatedUserId) return null

  return (
    <Chip
      data-testid="impersonation-chip"
      tone="caution"
      onRemove={stopImpersonation}
      removeButtonProps={
        {
          'data-testid': 'impersonation-chip-stop',
          'aria-label': 'Stop impersonating',
        } as ComponentProps<'button'>
      }
    >
      <span style={{ display: 'inline-flex', gap: 4 }}>
        <span>Impersonating</span>
        <EntityLink entityId={impersonatedUserId} showTooltip={false} />
      </span>
    </Chip>
  )
}

export default ImpersonationChip
